import React from 'react';
import Button from 'antd/lib/button';
import { CheckOutlined, LoadingOutlined } from '@ant-design/icons';
import { t } from 'utils/i18n';

interface Props {
    saving: boolean;
    hasUnsavedChanges: boolean;
    onSave(): void;
}

export default function SaveStatus({ saving, hasUnsavedChanges, onSave }: Props): JSX.Element {
    if (saving) {
        return (
            <Button
                type='text'
                className='cvat-annotation-header-save-button cvat-workspace-save-status'
                icon={<LoadingOutlined />}
                disabled
            >
                {t('Saving…')}
            </Button>
        );
    }

    return (
        <Button
            type='text'
            className='cvat-annotation-header-save-button cvat-workspace-save-status'
            data-unsaved={hasUnsavedChanges}
            // the icon prop gets antd's icon-to-text gap; an icon child next to bare text doesn't
            icon={hasUnsavedChanges ? undefined : <CheckOutlined />}
            onClick={hasUnsavedChanges ? onSave : undefined}
        >
            {hasUnsavedChanges ? t('Unsaved changes') : t('Saved')}
        </Button>
    );
}
